import dynamic from 'next/dynamic';
import { CreateEventSummaryProps } from './CreateEventSummary.types';

export const CreateEventSummary = dynamic<{ model: CreateEventSummaryProps }>(() =>
  import('./CreateEventSummary').then(mod => mod.CreateEventSummary)
);
